export const getIds = (data = []) => {
  const group = data.map((item) => item.group.trim())
  return [...new Set(group)]
}
export const getDataTable = (data = [], ids = []) => {
  const dataTable = {}

  ids.forEach((id) => {
    const groupItems = data.filter((item) => item.group === id)
    dataTable[id] = groupItems
  })

  return dataTable
}
